import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';
import Typography from '@mui/material/Typography';

import { MediaQuerys } from '../../styles/GlobalStyle';

const { desktop } = MediaQuerys;


export const Container = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        height: '100%',
        width: '100%',
    }
})

export const ContainerTopGrahps = styled('div')(({theme}) => {
    return {
        display: 'flex',
        flexDirection: 'row',
        gap: '1rem',
        height: '50%',
        width: '100%',
        [desktop]: { 
            flexWrap: 'wrap',
        }
    }
});

export const ContentGraphics = styled(Card)(({ width, height }) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        height: height,
        width: width,
        padding: '10px',
        borderRadius: '10px',
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        [desktop]: {
            flex: 1,
            minWidth: '300px',
        }
    }
});

export const ContainerGraphics = styled('div')(({ width, height }) => {
    return {
        display: 'flex',
        flexDirection: 'row',
        overflowX: 'auto',
        height: '100%',
        '&::-webkit-scrollbar': {
            height: '5px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        } 
    }
});

export const ContainerBottomGrahps = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'row',
        gap: '1rem',
        height: '50%',
        width: '100%',
        [desktop]: {
            flexWrap: 'wrap',
        }
    }
});

export const ContainerTreeMap = styled('div')(() => {
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    }
});

export const CustomTitleGraphics = styled(Typography)(() => {
    return {
        fontWeight: 'bold',
        fontSize: '14px',
        [desktop]: {
            whiteSpace: 'normal',
            lineHeight: 1.2  
        }
    }
})



